import React from "react";
import styles from "./specialAttributeCard.scss";
import SpecialAttributeDetail from "./SpecialAttributeDetail";

const SpecialAttributeCard = ({ attribute }) => (
  <div className={styles.container}>
    <SpecialAttributeDetail
      title={attribute.label ? attribute.label : attribute.title}
      value={attribute.value}
    />
  </div>
);

export default SpecialAttributeCard;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/SpecialSectionMobile/SpecialAttributeCard/index.tsx